module.exports = __webpack_public_path__ + "static/TANMEMORIES-Italic-0a3761663e0c0d837378189685ca8f28.ttf";